module.exports = __webpack_public_path__ + "assets/img/组 206@2x.9e16decd.png";